import * as $runtime from "../runtime.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Network$dJsonRPC from "../Network.JsonRPC/index.js";
import * as Record from "../Record/index.js";
import * as Record$dUnsafe$dUnion from "../Record.Unsafe.Union/index.js";
import * as Restaumatic$dForm$dAction from "../Restaumatic.Form.Action/index.js";
import * as Restaumatic$dForm$dEditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic$dForm$dFormField from "../Restaumatic.Form.FormField/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dPersistence from "../Restaumatic.Form.Persistence/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dQueryTotal from "../Restaumatic.Form.QueryTotal/index.js";
import * as Restaumatic$dForm$dReadOnly from "../Restaumatic.Form.ReadOnly/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dForm$dTotality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic$dForm$dValidation from "../Restaumatic.Form.Validation/index.js";
import * as Restaumatic$dForm$dValue from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic$dForm$dWidgets from "../Restaumatic.Form.Widgets/index.js";
import * as Restaumatic$dForm$dWidgets$dBootstrap from "../Restaumatic.Form.Widgets.Bootstrap/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMarketing$dConsent$dRPC$dSites$dTypes from "../Restaumatic.Marketing.Consent.RPC.Sites.Types/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dSite$dRPC from "../Restaumatic.Site.RPC/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic$dStorage from "../Restaumatic.Storage/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidget from "../Specular.Dom.Widget/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Type$dAnnEquality from "../Type.AnnEquality/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const accountIdIsSymbol = {reflectSymbol: () => "accountId"};
const emailIsSymbol = {reflectSymbol: () => "email"};
const isAMIsSymbol = {reflectSymbol: () => "isAM"};
const phoneIsSymbol = {reflectSymbol: () => "phone"};
const submitIsSymbol = {reflectSymbol: () => "submit"};
const successIsSymbol = {reflectSymbol: () => "success"};
const maybeGetInitialValue1 = /* #__PURE__ */ (() => ({maybeGetInitialValue: Restaumatic$dForm$dInternal.maybeGetInitialValue$pFals["maybeGetInitialValue'"](Type$dProxy.Proxy)}))();
const mergeFormField$p = /* #__PURE__ */ Restaumatic$dForm$dFormField.mergeFormField$p(Type$dEquality.refl);
const queryFormField$p = /* #__PURE__ */ Restaumatic$dForm$dFormField.queryFormField$p(Type$dEquality.refl);
const initializePersistentIniti = /* #__PURE__ */ Restaumatic$dForm$dPersistence.initializePersistentIniti(/* #__PURE__ */ Restaumatic$dForm$dFormField.initializeRecordFormField({
  fromDefaults: b => a => Record$dUnsafe$dUnion.unsafeUnionFn(a, b)
})(Restaumatic$dForm$dTotality.isTotalityTotal)()({getInitialValue: v => v1 => Restaumatic$dForm$dValue.$Value("SomeValue", Data$dMaybe.Nothing)}))({
  decode: /* #__PURE__ */ Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)
})({
  encode: v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
})(mergeFormField$p)(queryFormField$p)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p);
const initializeNoInitialValueR = /* #__PURE__ */ Restaumatic$dForm$dReadOnly.initializeNoInitialValueR(Type$dAnnEquality.annTypeEquals)(Type$dAnnEquality.annTypeEquals);
const make = /* #__PURE__ */ (() => Restaumatic$dForm$dInternal.make(monadFRP)(Restaumatic$dForm$dInternal.initializeNoInitialValueR(Restaumatic$dForm$dInternal.initializeSomeInitialValu(Restaumatic$dForm$dInternal.asRecordRecord)()(Restaumatic$dForm$dInternal.initializeRecordCons(accountIdIsSymbol)(Restaumatic$dForm$dInternal.initializeRecordCons(emailIsSymbol)(Restaumatic$dForm$dInternal.initializeRecordCons(isAMIsSymbol)(Restaumatic$dForm$dInternal.initializeRecordCons(phoneIsSymbol)(Restaumatic$dForm$dInternal.initializeRecordCons(submitIsSymbol)(Restaumatic$dForm$dInternal.initializeRecordCons(successIsSymbol)(Restaumatic$dForm$dInternal.initializeRecordNil)(maybeGetInitialValue1)({
  maybeGetInitializer: Restaumatic$dForm$dInternal.maybeGetInitializer$pFalse["maybeGetInitializer'"](Type$dProxy.Proxy)
})({
  makeImpl: Restaumatic$dForm$dInternal.makeWithDefaultInitializer(Restaumatic$dForm$dFormField.initializeArrayFormField$p(Type$dAnnEquality.annTypeEquals)({
    getInitialValue: v => v1 => Restaumatic$dForm$dValue.$Value("SomeValue", false)
  })(Restaumatic$dForm$dTotality.isTotalityTotal))([])
})()())(maybeGetInitialValue1)({maybeGetInitializer: label => Record.get(submitIsSymbol)()(label)})(Restaumatic$dForm$dAction.initializeNoInitialValueA(Type$dAnnEquality.annTypeEquals))()())(maybeGetInitialValue1)({
  maybeGetInitializer: label => Record.get(phoneIsSymbol)()(label)
})(initializePersistentIniti)()())(maybeGetInitialValue1)({maybeGetInitializer: label => Record.get(isAMIsSymbol)()(label)})(initializeNoInitialValueR)()())(maybeGetInitialValue1)({
  maybeGetInitializer: label => Record.get(emailIsSymbol)()(label)
})(initializePersistentIniti)()())(maybeGetInitialValue1)({maybeGetInitializer: label => Record.get(accountIdIsSymbol)()(label)})(initializeNoInitialValueR)()()))))();
const sitesRPC = /* #__PURE__ */ Restaumatic$dSite$dRPC.sitesRPC(/* #__PURE__ */ Network$dJsonRPC.encodeRequest(Restaumatic$dMarketing$dConsent$dRPC$dSites$dTypes.encodeWithdrawMarketingConsentRequest)({
  encodeWithOptions: v => Restaumatic$dMarketing$dConsent$dRPC$dSites$dTypes.encodeWithdrawMarketingConsentRequest.encode
}))(/* #__PURE__ */ Network$dJsonRPC.decodeResponse(Foreign$dGeneric$dClass.unitDecode))(Restaumatic$dMarketing$dConsent$dRPC$dSites$dTypes.rpcMethodNameWithdrawMarketingConsentRequest);
const queryReadOnly$p = /* #__PURE__ */ Restaumatic$dForm$dReadOnly.queryReadOnly$p(Type$dEquality.refl);
const queryRecord = /* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecord({fromRecord: Unsafe$dCoerce.unsafeCoerce, toRecord: Unsafe$dCoerce.unsafeCoerce})()(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons(accountIdIsSymbol)(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons(emailIsSymbol)(/* #__PURE__ */ Restaumatic$dForm$dQuery.queryRecordCons(phoneIsSymbol)(Restaumatic$dForm$dQuery.queryRecordNilTotal)(queryFormField$p)()()()()())(queryFormField$p)()()()()())(queryReadOnly$p)()()()()());
const query = /* #__PURE__ */ Restaumatic$dForm$dQuery.queryWith({queryImpl: s => v => Specular$dFRP$dBase.bindDynamic.bind(v)(field => queryRecord.queryImpl(s)(field))})(Restaumatic$dForm$dQuery.Strict);
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const write = /* #__PURE__ */ (() => {
  const $0 = Restaumatic$dForm$dInternal.mergeDelayed(mergeFormField$p);
  return field => value => Effect$dAff._liftEffect($0.merge(value)(field));
})();
const textField = /* #__PURE__ */ Restaumatic$dForm$dWidgets$dBootstrap.textField(Restaumatic$dForm$dFormField.hasErrorsFormField$p)(Restaumatic$dForm$dWidgets$dBootstrap.labelString)(/* #__PURE__ */ Restaumatic$dForm$dFormField.isTextFieldFormField$p(/* #__PURE__ */ Restaumatic$dForm$dEditAsString.editAsStringMaybe(Restaumatic$dForm$dEditAsString.editAsStringString)))(Restaumatic$dForm$dFormField.hasLabelFormField$p)(Restaumatic$dForm$dFormField.hasFieldIdFormField$p)()();
const query1 = /* #__PURE__ */ Restaumatic$dForm$dQuery.queryWith(queryRecord)(Restaumatic$dForm$dQuery.Strict);
const queryTotal = /* #__PURE__ */ Restaumatic$dForm$dQueryTotal.queryTotal(queryReadOnly$p);
const whenD = /* #__PURE__ */ Specular$dFRP$dExtra.whenD(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const dynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.dynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const queryTotal1 = /* #__PURE__ */ Restaumatic$dForm$dQueryTotal.queryTotal(queryFormField$p);
const init = env => Specular$dInternal$dRIO.bindImpl(Restaumatic$dStorage.localStorage)(storage => make(["Consents"])(form => (
  {
    email: Restaumatic$dForm$dPersistence.$PersistentInitializer(
      storage,
      Data$dMaybe.$Maybe("Just", "consents:email"),
      {validations: Data$dFunctor.arrayMap(Restaumatic$dForm$dInternal.validateJust)([Restaumatic$dForm$dValidation.email])}
    ),
    phone: Restaumatic$dForm$dPersistence.$PersistentInitializer(
      storage,
      Data$dMaybe.$Maybe("Just", "consents:phone"),
      {validations: Data$dFunctor.arrayMap(Restaumatic$dForm$dInternal.validateJust)([Restaumatic$dForm$dValidation.phoneNumber])}
    ),
    accountId: (() => {
      const $0 = env.accountId;
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($0);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })(),
    isAM: (() => {
      const $0 = env.themeName === "active_menu";
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($0);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })(),
    submit: (() => {
      const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(query(form)));
      return () => {
        const v = $0();
        return for_(v)(request => {
          const $1 = Effect$dAff._makeFiber(
            Effect$dAff.ffiUtil,
            Effect$dAff._bind(Effect$dAff._map(Data$dEither.isRight)(sitesRPC(request)))(response => write(Specular$dFRP$dBase.functorDynamic.map(Data$dRecord.unsafeGet("success"))(form))(response))
          );
          return () => {
            const fiber = $1();
            fiber.run();
          };
        })();
      };
    })()
  }
)));
const displaySuccess = /* #__PURE__ */ Specular$dDom$dElement.el("div")([/* #__PURE__ */ Specular$dDom$dElement.classes(["alert, alert-success"])])(/* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dDom$dElement.el("span")([
  /* #__PURE__ */ Specular$dDom$dElement.attr("aria-hidden")("true"),
  /* #__PURE__ */ Specular$dDom$dElement.classes(["icon-ok", "icon-green"])
])(Restaumatic$dPrelude$dSpecular.wempty))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.consents.success_message),
  {}
)))));
const consentsForm = form => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el_("h4")(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.consents.description),
  {}
))))(() => Specular$dInternal$dRIO.bindImpl(textField({
  field: form.phone,
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.consents.form.phone.label), {})
}))(() => Specular$dInternal$dRIO.bindImpl(textField({
  field: form.email,
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.consents.form.email.label), {})
}))(() => Specular$dDom$dElement.el("button")([
  Specular$dDom$dElement.classes(["btn", "btn-primary"]),
  Specular$dDom$dElement.attr("type")("button"),
  Specular$dDom$dElement.attrWhenD(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.isNothing)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(query1(form))))("disabled")("true"),
  Specular$dDom$dElement.onClick_((() => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(form.submit.effect._1);
    return () => {
      const e = $0();
      return e()();
    };
  })()),
  Restaumatic$dForm$dWidgets.fieldId(Restaumatic$dForm$dAction.hasFieldIdAction)(form.submit)
])(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.consents.form.submit),
  {}
))))));
const amPagination = /* #__PURE__ */ Specular$dDom$dElement.el("nav")([/* #__PURE__ */ Specular$dDom$dElement.class_("m-pagination m-pagination--pager")])(/* #__PURE__ */ Specular$dDom$dElement.el("ul")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("m-pagination__list")
])(/* #__PURE__ */ Specular$dDom$dElement.el("li")([/* #__PURE__ */ Specular$dDom$dElement.class_("m-pagination__list-item")])(/* #__PURE__ */ Specular$dDom$dElement.el("a")([
  /* #__PURE__ */ Specular$dDom$dElement.class_("m-pagination__item"),
  /* #__PURE__ */ Specular$dDom$dElement.attr("href")("javascript:history.back();")
])(/* #__PURE__ */ Specular$dInternal$dRIO.bindImpl(/* #__PURE__ */ Specular$dDom$dElement.el("span")([/* #__PURE__ */ Specular$dDom$dElement.attr("aria-hidden")("true")])(/* #__PURE__ */ Specular$dDom$dElement.text("«")))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(" "))(() => Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
  Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.generic.back),
  {}
))))))));
const content = form => {
  const isAM = queryTotal(form.isAM);
  return Specular$dInternal$dRIO.bindImpl(whenD(isAM)(amPagination))(() => Specular$dInternal$dRIO.bindImpl(dynamic_(Specular$dFRP$dBase.functorDynamic.map(v => {
    if (v) { return displaySuccess; }
    return consentsForm(form);
  })(queryTotal1(form.success))))(() => whenD(isAM)(amPagination)));
};
const run = cfg => {
  const $0 = Specular$dDom$dWidget.runWidgetInNode(cfg.container)(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.bindImpl(init({
    accountId: cfg.accountId,
    themeName: cfg.themeName
  }))(form => content(form)))(() => Specular$dInternal$dRIO.pureImpl({})));
  return () => {
    const a$p = $0();
    return a$p._1;
  };
};
export {
  accountIdIsSymbol,
  amPagination,
  consentsForm,
  content,
  displaySuccess,
  dynamic_,
  emailIsSymbol,
  for_,
  init,
  initializeNoInitialValueR,
  initializePersistentIniti,
  isAMIsSymbol,
  make,
  maybeGetInitialValue1,
  mergeFormField$p,
  monadFRP,
  phoneIsSymbol,
  query,
  query1,
  queryFormField$p,
  queryReadOnly$p,
  queryRecord,
  queryTotal,
  queryTotal1,
  run,
  sitesRPC,
  submitIsSymbol,
  successIsSymbol,
  textField,
  whenD,
  write
};
